<div class="roles-directory-page" style="padding: 120px 40px 100px;">

  <!-- Step 2 of the access chain -->
  <app-policy-flow-steps active="roles"></app-policy-flow-steps>

  <!-- Header & Action Bar -->
  <div class="contests-header mb-4">
    <div>
      <h2 class="page-title">{{ 'roles-page.directory-title' | translate }}</h2>
      <p class="page-subtitle text-muted mb-0">{{ 'roles-page.directory-subtitle' | translate }}</p>
    </div>

    <div class="top-filters">
      <!-- Search -->
      <div class="search-bar">
        <div class="icon">
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
        <input type="text" [(ngModel)]="searchTerm" [placeholder]="'roles-page.search-placeholder' | translate" />
      </div>

      <!-- + New Role Button -->
      <button class="btn btn-primary" (click)="openCreateModal()">
        <i class="fa-solid fa-plus" style="margin-inline-end: 8px;"></i>
        <span>{{ 'roles-page.new-role' | translate }}</span>
      </button>
    </div>
  </div>


  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status" style="color: #5304FB !important;">
      <span class="visually-hidden">{{ 'roles-page.loading-roles' | translate }}</span>
    </div>
    <div class="mt-2 text-muted small">{{ 'roles-page.loading-directory' | translate }}</div>
  </div>

  <!-- Roles Table -->
  <div *ngIf="!isLoading" class="luqta-card p-0 overflow-hidden border">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0 roles-table">
        <thead>
          <tr class="text-muted small">
            <th class="ps-4 py-3" style="width: 24%;">Role</th>
            <th class="py-3" style="width: 28%;">Description</th>
            <th class="py-3" style="width: 14%;">Pages Allowed</th>
            <th class="py-3" style="width: 14%;">Sub-Users</th>
            <th class="text-end pe-4 py-3" style="width: 20%;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let role of filteredRoles">
            <!-- Role -->
            <td class="ps-4 py-3">
              <div class="d-flex align-items-center gap-3">
                <div class="role-avatar" [style.background]="role.color + '15'" [style.color]="role.color">
                  <i [class]="role.icon || 'fa-solid fa-shield-halved'"></i>
                </div>
                <div>
                  <h5 class="role-name mb-0">{{ role.policy_name }}</h5>
                  <span class="role-badge badge-custom">ID: #{{ role.id }}</span>
                </div>
              </div>
            </td>

            <!-- Description -->
            <td class="py-3">
              <p class="role-desc mb-0">
                {{ role.description || 'Custom organizational policy defining specific client portal page permissions.'
                }}
              </p>
            </td>

            <!-- Pages this role can open -->
            <td class="py-3">
              <span class="pages-pill" [class.none]="!role.grantedPages">
                <i class="fa-solid fa-file-lines"></i>
                <strong>{{ role.grantedPages || 0 }}</strong>
                <span class="of-total" *ngIf="role.totalPages">/ {{ role.totalPages }}</span>
              </span>
            </td>

            <!-- Assigned sub-users -->
            <td class="py-3">
              <span class="sub-user-pill">
                <i class="fa-solid fa-users"></i>
                <strong>{{ role.memberCount || 0 }}</strong>
                {{ (role.memberCount === 1) ? 'sub-user' : 'sub-users' }}
              </span>
            </td>

            <!-- Actions -->
            <td class="text-end pe-4 py-3">
              <div class="d-flex align-items-center justify-content-end gap-2">
                <button class="btn btn-primary btn-configure" (click)="navigateToManage(role.id, 'permissions')">
                  <i class="fa-solid fa-sliders me-1"></i>
                  Configure
                </button>
                <button class="btn-icon-action" (click)="navigateToManage(role.id, 'users')"
                  title="Assign sub-users to this role">
                  <i class="fa-solid fa-user-plus"></i>
                </button>
                <button class="btn-icon-action" (click)="openEditModal(role, $event)" title="Edit Role">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button class="btn-icon-action btn-icon-danger" (click)="openDeleteModal(role, $event)"
                  title="Delete Role">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="filteredRoles.length === 0">
            <td colspan="5" class="text-center py-5">
              <i class="fa-solid fa-shield-halved text-muted mb-3 d-block" style="font-size: 42px;"></i>
              <h5 class="font-weight-600">No Roles Found</h5>
              <p class="text-muted small mb-4">
                {{ searchTerm ? 'No roles match your search filter.' : 'No custom roles have been created yet.' }}
              </p>
              <button class="btn btn-primary" (click)="openCreateModal()">
                <i class="fa-solid fa-plus me-2"></i> Create First Role
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Create Role Modal -->
  <nz-modal nzClassName="luqta-custom-modal" [nzCentered]="true" [(nzVisible)]="isCreateModalVisible"
    [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="modalFooter" (nzOnCancel)="closeCreateModal()"
    [nzWidth]="540">
    <ng-template #modalTitle>
      <div class="d-flex align-items-center gap-2">
        <div class="modal-role-icon"
          style="background: rgba(255, 255, 255, 0.2); color: #FFFFFF; width: 34px; height: 34px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px;">
          <i class="fa-solid fa-plus"></i>
        </div>
        <span style="font-family: 'Codec Pro'; font-weight: 600; font-size: 17px; color: #FFFFFF;">
          {{ 'roles-page.create-role-title' | translate }}
        </span>
      </div>
    </ng-template>

    <ng-template #modalContent>
      <div class="create-role-form py-3 px-1">
        <!-- Policy Name -->
        <div class="mb-4">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-name' | translate }} <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" [(ngModel)]="newRoleName" (input)="onRoleNameInput()"
            [placeholder]="'roles-page.role-name-placeholder' | translate"
            style="height: 48px; border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding-left: 16px;"
            [class.is-invalid]="!!inlineNameError" />
          <!-- Inline Error for duplicate name -->
          <div *ngIf="inlineNameError" class="text-danger mt-1.5 small d-flex align-items-center gap-1">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ inlineNameError }}</span>
          </div>
          <small class="text-muted d-flex align-items-center gap-1 mt-1.5" style="font-size: 12px;">
            <i class="fa-solid fa-circle-info" style="color: #5304FB;"></i>
            {{ 'roles-page.role-name-hint' | translate }}
          </small>
        </div>

        <!-- Description -->
        <div class="mb-2">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-desc' | translate }}
          </label>
          <textarea class="form-control" rows="3" [(ngModel)]="newRoleDescription"
            [placeholder]="'roles-page.role-desc-placeholder' | translate"
            style="border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding: 12px 16px;"></textarea>
        </div>
      </div>
    </ng-template>

    <ng-template #modalFooter>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <button class="btn btn-light"
          style="border-radius: 12px; height: 46px; padding: 0 22px; font-size: 14px; font-weight: 500; border: 1.5px solid rgba(0, 0, 0, 0.1); background: #FFFFFF; color: #344054;"
          (click)="closeCreateModal()" [disabled]="isSaving">
          {{ 'roles-page.cancel' | translate }}
        </button>
        <button class="btn btn-primary"
          style="border-radius: 12px; height: 46px; padding: 0 24px; font-size: 14px; font-weight: 600; background: #5304FB; border: none; color: #FFFFFF; box-shadow: 0 2px 8px rgba(83, 4, 251, 0.25);"
          (click)="handleCreateRole()" [disabled]="isSaving || !newRoleName.trim()">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSaving" class="fa-solid fa-plus me-2"></i>
          {{ isSaving ? ('roles-page.creating' | translate) : ('roles-page.create-role' | translate) }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

  <!-- Edit Role Modal -->
  <nz-modal nzClassName="luqta-custom-modal" [nzCentered]="true" [(nzVisible)]="isEditModalVisible"
    [nzTitle]="editModalTitle" [nzContent]="editModalContent" [nzFooter]="editModalFooter"
    (nzOnCancel)="closeEditModal()" [nzWidth]="540">
    <ng-template #editModalTitle>
      <div class="d-flex align-items-center gap-2">
        <div class="modal-role-icon"
          style="background: rgba(255, 255, 255, 0.2); color: #FFFFFF; width: 34px; height: 34px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px;">
          <i class="fa-solid fa-pen-to-square"></i>
        </div>
        <span style="font-family: 'Codec Pro'; font-weight: 600; font-size: 17px; color: #FFFFFF;">
          {{ 'roles-page.edit-role-title' | translate }} #{{ editingRole?.id }}
        </span>
      </div>
    </ng-template>

    <ng-template #editModalContent>
      <div class="create-role-form py-3 px-1">
        <!-- Role Name -->
        <div class="mb-4">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-name' | translate }} <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" [(ngModel)]="editRoleName" (input)="onEditRoleNameInput()"
            [placeholder]="'roles-page.role-name-placeholder' | translate"
            style="height: 48px; border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding-left: 16px;"
            [class.is-invalid]="!!inlineEditNameError" />
          <div *ngIf="inlineEditNameError" class="text-danger mt-1.5 small d-flex align-items-center gap-1">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ inlineEditNameError }}</span>
          </div>
        </div>

        <!-- Description -->
        <div class="mb-2">
          <label class="form-label font-weight-600 mb-2" style="color: #344054; font-size: 13.5px;">
            {{ 'roles-page.role-desc' | translate }}
          </label>
          <textarea class="form-control" rows="3" [(ngModel)]="editRoleDescription"
            [placeholder]="'roles-page.role-desc-placeholder' | translate"
            style="border-radius: 12px; font-size: 14px; background: #FAF9FF; border: 1.5px solid #E4E7EC; padding: 12px 16px;"></textarea>
        </div>
      </div>
    </ng-template>

    <ng-template #editModalFooter>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <button class="btn btn-light"
          style="border-radius: 12px; height: 46px; padding: 0 22px; font-size: 14px; font-weight: 500; border: 1.5px solid rgba(0, 0, 0, 0.1); background: #FFFFFF; color: #344054;"
          (click)="closeEditModal()" [disabled]="isUpdating">
          {{ 'roles-page.cancel' | translate }}
        </button>
        <button class="btn btn-primary"
          style="border-radius: 12px; height: 46px; padding: 0 24px; font-size: 14px; font-weight: 600; background: #5304FB; border: none; color: #FFFFFF; box-shadow: 0 2px 8px rgba(83, 4, 251, 0.25);"
          (click)="handleUpdateRole()" [disabled]="isUpdating || !editRoleName.trim()">
          <span *ngIf="isUpdating" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isUpdating" class="fa-solid fa-check me-2"></i>
          {{ isUpdating ? ('roles-page.saving' | translate) : ('roles-page.save-changes' | translate) }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

  <!-- Delete Role Confirmation Modal -->
  <nz-modal nzClassName="luqta-custom-modal" [nzCentered]="true" [(nzVisible)]="isDeleteModalVisible"
    [nzTitle]="deleteModalTitle" [nzContent]="deleteModalContent" [nzFooter]="deleteModalFooter"
    (nzOnCancel)="closeDeleteModal()" [nzWidth]="480">
    <ng-template #deleteModalTitle>
      <div class="d-flex align-items-center gap-2">
        <div class="modal-role-icon"
          style="background: rgba(239, 68, 68, 0.2); color: #EF4444; width: 34px; height: 34px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px;">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <span style="font-family: 'Codec Pro'; font-weight: 600; font-size: 17px; color: #101828;">
          {{ 'roles-page.delete-role-title' | translate }}
        </span>
      </div>
    </ng-template>

    <ng-template #deleteModalContent>
      <div class="py-3 px-1">
        <p style="font-size: 14.5px; color: #344054; line-height: 1.5;">
          {{ 'roles-page.delete-confirm-question' | translate:{ name: getRoleDisplayName(deletingRole), id:
          deletingRole?.id } }}
        </p>

        <div *ngIf="(deletingRole?.memberCount || 0) > 0"
          class="alert alert-warning d-flex align-items-start gap-2 p-3 mt-3 mb-0"
          style="border-radius: 10px; background: #FFFBEB; border: 1px solid #FDE68A; color: #B45309; font-size: 13px;">
          <i class="fa-solid fa-triangle-exclamation mt-0.5"></i>
          <div>
            {{ 'roles-page.delete-warning' | translate:{ count: deletingRole?.memberCount } }}
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #deleteModalFooter>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <button class="btn btn-light"
          style="border-radius: 12px; height: 44px; padding: 0 20px; font-size: 14px; font-weight: 500; border: 1.5px solid rgba(0, 0, 0, 0.1); background: #FFFFFF; color: #344054;"
          (click)="closeDeleteModal()" [disabled]="isDeleting">
          {{ 'roles-page.cancel' | translate }}
        </button>
        <button class="btn btn-danger"
          style="border-radius: 12px; height: 44px; padding: 0 22px; font-size: 14px; font-weight: 600; background: #EF4444; border: none; color: #FFFFFF;"
          (click)="handleDeleteRole()" [disabled]="isDeleting">
          <span *ngIf="isDeleting" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isDeleting" class="fa-solid fa-trash-can me-2"></i>
          {{ isDeleting ? ('roles-page.saving' | translate) : ('roles-page.delete-role' | translate) }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

</div>